import React from 'react';
import PropTypes from 'prop-types';
import rehypeReact from 'rehype-react';

import ArticleCard from '../cards/articleCard';

const Blogs = ({ headline, subheading, items }) => {
	const renderSubheadingAst = new rehypeReact({
		createElement: React.createElement,
		components: {
			p: ({ children }) => (
				<p className="typography typography--subtle-big">{children}</p>
			),
		},
	}).Compiler;

	return (
		<div className="blogs section">
			<div className="section__content">
				{headline && (
					<>
						<h2 className="typography typography--h2">{headline}</h2>
						{renderSubheadingAst(subheading?.childMarkdownRemark?.htmlAst)}
					</>
				)}
				<div className="blogs__cards">
					{items.map(
						({ id, date, excerpt, slug, headerImage, compose__page }) => {
							const { name } = compose__page[0] || {};
							return (
								<ArticleCard
									key={id}
									article={{
										headerImage,
										category: '',
										title: name,
										date,
										body: excerpt,
										link: slug,
									}}
								/>
							);
						}
					)}
				</div>
			</div>
		</div>
	);
};

Blogs.propTypes = {
	headline: PropTypes.string,
	subheading: PropTypes.shape({
		childMarkdownRemark: PropTypes.shape({ htmlAst: PropTypes.object }),
	}),
	items: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			category: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			date: PropTypes.string.isRequired,
			body: PropTypes.string.isRequired,
			link: PropTypes.string.isRequired,
			headerImage: PropTypes.shape({
				data: PropTypes.object,
				src: PropTypes.string,
				alt: PropTypes.string,
			}),
		})
	),
};

Blogs.defaultProps = {
	headline: null,
	subheading: {},
	items: [],
};

export default Blogs;
